(function(algolia) {
  'use strict';
  var instantsearch = algolia.externals.instantsearch;
  var algoliasearch = algolia.externals.algoliasearch;
  var searchBox = algolia.externals.widgets.searchBox;
  var stats = algolia.externals.widgets.stats;
  var sortBy = algolia.externals.widgets.sortBy;
  var clearRefinements = algolia.externals.widgets.clearRefinements;
  var panel = algolia.externals.widgets.panel;
  var hits = algolia.externals.widgets.hits;
  var ratingMenu = algolia.externals.widgets.ratingMenu;
  var pagination = algolia.externals.widgets.pagination;
  var configure = algolia.externals.widgets.configure;
  var connectCurrentRefinements = algolia.externals.connectors.connectCurrentRefinements;
  var aa = algolia.externals.aa;
  var queryRuleCustomData = algolia.externals.widgets.queryRuleCustomData;
  var connectRefinementList = algolia.externals.connectors.connectRefinementList;

  var collectionPage = Boolean(algolia.is_collection_results_page) && Boolean(algolia.config.instant_search_enabled_on_collection);

  if ((!algolia.full_results && !collectionPage) || !algolia.config.instant_search_enabled) {
    return;
  }

  /**
   * Array which will contain all filters to be applied while initiating the
   * search API call.
   */
  var searchFilters = [];

  var collectionFacetFilter = null;
  var collectionRulesContextValue = null;
  if (collectionPage) {
    var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
    var handle = Boolean(matches) && matches.length === 2 ? matches[1] : null;

    if (algolia.config.collection_id_indexing) {
      collectionFacetFilter = algolia.current_collection_id ? 'collection_ids:"' + algolia.current_collection_id + '"' : null;
    } else {
      collectionFacetFilter = 'collections:"' + handle + '"';
    }

    // Add the collection filter to the list of search filters
    searchFilters.push(collectionFacetFilter);

    collectionRulesContextValue = algolia.config.collection_id_query_rules ? algolia.current_collection_id : handle;
  }

  // Filters for stock policy
  var stockPolicyFilter = null;
  if (algolia.config.stock_policy) {
    if (algolia.config.stock_policy === 'allow') {
      /**
       * For 'allow', we don't need to add any filter as we want to continue
       * displaying all out of stock items.
       */
    } else if (algolia.config.stock_policy === 'deny') {
      // For 'deny' we will filter out all items based on inventory quantity
      stockPolicyFilter = 'inventory_quantity > 0';
    } else if (algolia.config.stock_policy === 'continue') {
      /**
       * For 'continue' we will filter on `inventory_available` attribute whose
       * value is dependent on:
       * `inventory_quantity > 0 OR inventory_policy == 'continue'`
       */
      stockPolicyFilter = 'inventory_available:true';
    }

    // Add the stock policy filter to the list of search filters
    if (stockPolicyFilter) {
      searchFilters.push(stockPolicyFilter);
    }
  }

  var results_selector = collectionPage ? algolia.config.collection_css_selector : algolia.config.results_selector;
  var activeSortOrders = collectionPage && algolia.collectionSortOrders ? algolia.collectionSortOrders : algolia.sortOrders;
  results_selector += ', .algolia-shopify-instantsearch';

  function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function(k) {
      if (k === 'configure' || k === 'query' || k === 'q') {
        return;
      }
      trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
  }

  function singleIndex(indexName) {
    return {
      stateToRoute: function(uiState) {
        var route = getTrackedUiState(uiState[indexName] || {});
        route.q = uiState[indexName].query;
        return route;
      },
      routeToState: function(routeState) {
        var state = {};
        state[indexName] = getTrackedUiState(routeState || {});
        state[indexName].query = routeState.q;
        return state;
      },
    };
  }

  var route = {
    stateMapping: singleIndex(algolia.config.index_prefix + 'products'),
    router: instantsearch.routers.history({
      createURL({ qsModule, location, routeState }) {
        // current search params
        const { origin, pathname, hash, search } = location;
        let queryParameters = routeState;

        // Fixes routing for utm collections
        if (collectionPage) {
          // grab current query string and convert to object
          queryParameters = qsModule.parse(search.slice(1)) || {};

          // if there is an active search
          if (Object.keys(routeState).length) {
            if (!routeState.refinementList) {
              delete queryParameters.refinementList
            }

            if (!routeState.sortBy) {
              delete queryParameters.sortBy
            }

            if (!routeState.page) {
              delete queryParameters.page
            }

            // merge the search params with the current query params
            Object.assign(queryParameters, routeState);
          }
        }

        let queryString = qsModule.stringify(queryParameters);

        if (queryString.length) {
          queryString = `?${queryString}`;
        }

        return `${origin}${pathname}${queryString}${hash}`;
      }
    }),
  }

  var instant = {
    colors: algolia.config.colors,
    distinct: Boolean(algolia.config.show_products),
    facets: {
      hidden: collectionPage && algolia.collectionHiddenFacets ? algolia.collectionHiddenFacets : algolia.hiddenFacets,
      shown: collectionPage && algolia.collectionShownFacets ? algolia.collectionShownFacets : algolia.shownFacets,
      list: collectionPage && algolia.collectionFacets ? algolia.collectionFacets : algolia.facets,
      widgets: collectionPage && algolia.collectionFacetsWidgets ? algolia.collectionFacetsWidgets : algolia.facetsWidgets,
    },
    hitsPerPage:
      collectionPage && algolia.config.collections_full_results_hits_per_page ? algolia.config.collections_full_results_hits_per_page : algolia.config.products_full_results_hits_per_page,
    search: instantsearch({
      searchClient: algoliasearch(algolia.config.app_id, algolia.config.search_api_key),
      indexName: algolia.config.index_prefix + 'products',
      routing: route,
      searchFunction: function(searchFunctionHelper) {
        // Set query parameters here because they're not kept when someone
        // presses the Back button if set in the `init` function of a custom widget
        var page = searchFunctionHelper.getPage()

        searchFunctionHelper.setQueryParameter('highlightPreTag', '<span class="ais-highlight">');
        searchFunctionHelper.setQueryParameter('highlightPostTag', '</span>');
        if (instant.distinct) {
          searchFunctionHelper.setQueryParameter('distinct', true);
        }

        // Assign any required filters
        if (searchFilters.length) {
          searchFunctionHelper.setQueryParameter('filters', searchFilters.join(' AND '));
        }

        // Assign any required `ruleContexts` which are required for query rules
        // targeting collection pages
        if (collectionPage) {
          // Collection page merchandising:
          // If we are on a collection page, `collectionRulesContextValue` is defined
          if (collectionRulesContextValue) {
            searchFunctionHelper.setQueryParameter('ruleContexts', [
              collectionRulesContextValue.toString(),
            ]);
          } else {
            searchFunctionHelper.setQueryParameter('ruleContexts', []);
          }
        }

        searchFunctionHelper.setPage(page);
        searchFunctionHelper.search();
      },
    }),
    selector: results_selector + ', .algolia-shopify-instantsearch',
    sortOrders: activeSortOrders,
    storeName: algolia.storeName,
    templates: {
      currentItem: algolia.getTemplate(
        'instant_search_current_refined_values_item'
      ),
      empty: algolia.getTemplate('instant_search_no_result'),
      page: algolia.compileTemplate('instant_search'),
      product: algolia.getTemplate('instant_search_product'),
      stats: algolia.getTemplate('instant_search_stats'),
      style: algolia.compileTemplate('instant_search.css'),
    },
  };

  algolia.instantsearch = instant;

  function readjust() {
    var width = instant.$results.offsetWidth;

    var suffix = 'lg';
    if (width < 400) suffix = 'xs';
    else if (width < 800) suffix = 'sm';
    else if (width < 1200) suffix = 'md';

    instant.$results.classList.remove('ais-results-size-xs');
    instant.$results.classList.remove('ais-results-size-sm');
    instant.$results.classList.remove('ais-results-size-md');
    instant.$results.classList.remove('ais-results-size-lg');
    instant.$results.classList.add('ais-results-size-' + suffix);
  }

  // Bind helpers
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  Object.keys(helpers).forEach(function(name) {
    var helper = helpers[name];
    instant.search.templatesConfig.helpers[name] = helper;
  });
  instant.search.templatesConfig.compileOptions = algolia.hoganOptions;

  algolia.appendStyle(
    algolia.render(instant.templates.style, {
      distinct: instant.distinct,
      colors: instant.colors,
    })
  );

  if (collectionPage && document.querySelectorAll(algolia.config.collection_css_selector).length === 0) {
    throw new Error(
      'Instant search CSS selector for collection page is incorrect\nFore more info see : https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector'
    );
  } else if (document.querySelectorAll(algolia.config.results_selector).length === 0) {
    throw new Error(
      'Instant search CSS selector is incorrect\nFore more info see : https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector'
    );
  }

  instant.$results = document.querySelector(instant.selector);

  instant.$results.innerHTML = algolia.render(instant.templates.page, {
    facets: instant.facets.list,
    storeName: instant.storeName,
    translations: algolia.translations,
    multipleSortOrders: activeSortOrders.length > 1,
  });

  readjust();

  window.addEventListener('resize', function() {
    readjust();
  });

  // Mobile facets display
  instant.search.addWidgets([
    {
      init: function() {
        var $button = document.querySelector('.ais-facets-button');
        var $body = document.body;

        $button.addEventListener('click', function() {
          var activeFilters = document.querySelectorAll('.ais-current-refined-values--item')
          var $facets = document.querySelector('.ais-facets');

          if ($facets.classList.contains('ais-facets__shown')) {
            if (activeFilters.length) {
              $button.classList.add('bg-light-teal')
            } else {
              $button.classList.remove('bg-light-teal')
            }
            $button.textContent = activeFilters.length ? `Show filters (${activeFilters.length})` : 'Show filters';
            $facets.classList.remove('ais-facets__shown');
            $body.classList.remove('ais-facets-filters__shown');
          } else {
            $button.textContent = activeFilters.length ? `Hide filters (${activeFilters.length})` : 'Hide filters';
            $facets.classList.add('ais-facets__shown');
            $body.classList.add('ais-facets-filters__shown');
          }
        });

        var $facetsCloseButtons = document.querySelectorAll('.ais-facets__close');
        $facetsCloseButtons.forEach(ele => {
          ele.addEventListener('click', event => {
            var activeFilters = document.querySelectorAll('.ais-current-refined-values--item')
            var $facets = document.querySelector('.ais-facets');
            if (activeFilters.length) {
              $button.classList.add('bg-light-teal')
            } else {
              $button.classList.remove('bg-light-teal')
            }
            $button.textContent = activeFilters.length ? `Show filters (${activeFilters.length})` : 'Show filters';
            $facets.classList.remove('ais-facets__shown');
            $body.classList.remove('ais-facets-filters__shown');
          })
        })
      },
    },
  ]);

  instant.search.addWidgets([
    configure({
      hitsPerPage: instant.hitsPerPage,
      clickAnalytics: true,
      facetingAfterDistinct: false
    }),
  ]);

  // Search input
  instant.search.addWidgets([
    searchBox({
      container: '.ais-search-box-container',
      placeholder: algolia.translations.searchForProduct,
      showReset: false,
      showSubmit: false,
    }),
  ]);

  // Clear input
  instant.search.addWidgets([
    {
      init: function(opts) {
        const searchLabel = document.createElement('label');
        const searchText = document.createElement('span');
        searchLabel.classList.add('hidden');
        searchText.classList.add('hidden');
        searchText.innerHTML = 'Algolia Search';
        document.querySelector('input.ais-SearchBox-input').before(searchLabel);
        searchLabel.appendChild(document.querySelector('input.ais-SearchBox-input'));
        searchLabel.appendChild(searchText);
        document.querySelector('.ais-clear-input-icon').addEventListener('click', function() {
          opts.helper.setQuery('').search();
          var input = document.querySelector('.ais-search-box--input');
          input.value = '';
          input.focus();
        });
      },
      render: function(opts) {
        if (!opts.state.query) {
          document.querySelector('.ais-clear-input-icon').style.display = 'none';
        } else {
          document.querySelector('.ais-clear-input-icon').style.display = '';
        }
      },
    },
  ]);

  // Stats
  instant.search.addWidgets([
    stats({
      container: '.ais-stats-container',
      templates: {
        text: instant.templates.stats,
      },
    }),
  ]);

  // Sort orders
  if (activeSortOrders.length > 1) {
    instant.search.addWidgets([
      sortBy({
        container: '.ais-sort-orders-container',
        items: instant.sortOrders,
      }),
    ]);

    instant.search.addWidgets([
      sortBy({
        container: '.ais-sortby-button',
        items: instant.sortOrders,
      }),
    ]);
  }

  // Change display
  instant.search.addWidgets([
    {
      init: function() {
        document.querySelector('.ais-search-header .ais-change-display-block').addEventListener('click', function() {
          document.querySelector('.ais-change-display-block:not(.ais-change-display-selected)').classList.add('ais-change-display-selected');
          document.querySelector('.ais-change-display-list.ais-change-display-selected').classList.remove('ais-change-display-selected');
          document.querySelector('.ais-hits-container').classList.remove('ais-results-as-list')
          document.querySelector('.ais-hits-container').classList.add('ais-results-as-block');
        });
        document.querySelector('.ais-search-header .ais-change-display-list').addEventListener('click', function() {
          document.querySelector('.ais-change-display-list:not(.ais-change-display-selected)').classList.add('ais-change-display-selected');
          document.querySelector('.ais-change-display-block.ais-change-display-selected').classList.remove('ais-change-display-selected');
          document.querySelector('.ais-hits-container').classList.remove('ais-results-as-block');
          document.querySelector('.ais-hits-container').classList.add('ais-results-as-list');
        });
      },
    },
  ]);

  // Hidden facets
  var list = instant.facets.hidden.map(function(facet) {
    return facet.name;
  });
  instant.search.addWidgets([
    {
      getConfiguration: function() {
        return {
          facets: list,
          disjunctiveFacets: list,
        };
      },
      init: function() { },
    },
  ]);

  // Create the render function
  var createDataAttribtues = function(refinement) {
    return Object.keys(refinement)
      .map(function(key) {
        return 'data-' + key + '="' + encodeURIComponent(refinement[key] || '') + '"';
      })
      .join(' ');
  };

  var renderListItem = function(item) {
    var facet = instant.facets.list.find(function(f) {
      return f.name === item.label;
    });

    var filterCloseIcon = `
      <?xml version="1.0" encoding="utf-8"?>
        <!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 20.6 20.6" style="enable-background:new 0 0 20.6 20.6;" xml:space="preserve">
        <style type="text/css">
          .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#ffffff;}
        </style>
        <path class="st0" d="M11.4,10.3l4.4-4.4c0.3-0.3,0.3-0.8,0-1.1c-0.3-0.3-0.8-0.3-1.1,0l-4.4,4.4L5.9,4.8c-0.3-0.3-0.8-0.3-1.1,0
          c-0.3,0.3-0.3,0.8,0,1.1l4.4,4.4l-4.4,4.4c-0.3,0.3-0.3,0.8,0,1.1c0.3,0.3,0.8,0.3,1.1,0l4.4-4.4l4.4,4.4c0.3,0.3,0.8,0.3,1.1,0
          c0.3-0.3,0.3-0.8,0-1.1L11.4,10.3z"/>
      </svg>

    `;
    return item.refinements
      .map(function(refinement) {
        if (facet.title == 'Price range') {
          return (
            '<li class="ais-current-refined-values--item">' +
            '  <a ' + createDataAttribtues(refinement) + ' class="ais-current-refined-values--link"><div>' +
            '    <div class="ais-current-refined-values--label">' + facet.title + '</div><b>: $' + refinement.label.replace(":", " - $") +
            '  </b></div>' +
            '   <span class="ais-current-refined-values--item__close">' + filterCloseIcon + '</span></a>' +
            '</li>'
          );
        }
        else {
          return (
            '<li class="ais-current-refined-values--item">' +
            '  <a ' + createDataAttribtues(refinement) + ' class="ais-current-refined-values--link"><div>' +
            '    <div class="ais-current-refined-values--label">' + facet.title + '</div><b>: ' + refinement.label.replace(":", " - ") +
            '  </b></div>' +
            '   <span class="ais-current-refined-values--item__close">' + filterCloseIcon + '</span></a>' +
            '</li>'
          );
        }
      })
      .join('');
  };

  var renderCurrentRefinements = function(renderOptions) {
    var items = renderOptions.items;
    var refine = renderOptions.refine;
    var widgetParams = renderOptions.widgetParams;

    widgetParams.container.innerHTML =
      '<div class="ais-root ais-current-refined-values ais-facet">' +
      '  <ul class="ais-current-refined-values--list">' +
      items.map(renderListItem).join('') +
      '  </ul>' +
      '</div>';

    Array.prototype.slice
      .call(
        widgetParams.container.querySelectorAll('.ais-current-refined-values--link')
      )
      .forEach(function(element) {
        element.addEventListener('click', function(event) {
          var item = Object.keys(event.currentTarget.dataset).reduce(function(acc, key) {
            var itemData = {};
            itemData[key] = decodeURIComponent(event.currentTarget.dataset[key]);
            return algolia.assign({}, acc, itemData);
          },
            {});

          refine(item);
        });
      });
  };

  // Create the custom widget
  var customCurrentRefinements = connectCurrentRefinements(
    renderCurrentRefinements
  );

  var hasRefinements = function(helper, facetsList) {
    return facetsList.some(function(f) {
      var isConjunctiveFacetRefined = helper.state.isConjunctiveFacet(f.name) && helper.state.isFacetRefined(f.name);
      var isDisjunctiveFacetRefined = helper.state.isDisjunctiveFacet(f.name) && helper.state.isDisjunctiveFacetRefined(f.name);
      var isHierarchicalFacetRefined = helper.state.isHierarchicalFacet(f.name) && helper.state.isHierarchicalFacetRefined(f.name);
      var numericRefinements = helper.state.getNumericRefinements(f.name);
      var isNumericFacetRefined = Object.keys(numericRefinements).some(function(operator) {
        return numericRefinements[operator].length > 0;
      });

      return (isNumericFacetRefined || isConjunctiveFacetRefined || isDisjunctiveFacetRefined || isHierarchicalFacetRefined);
    });
  };

  var customCurrentRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(customCurrentRefinements);

  var clearRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(clearRefinements);

  instant.search.addWidgets([
    clearRefinementsWithPanel({
      container: document.querySelector('.ais-clear-refinements-container'),
      templates: {
        resetLabel: algolia.translations.clearAll,
      },
    }),
    customCurrentRefinementsWithPanel({
      container: document.querySelector(
        '.ais-current-refined-values-container'
      ),
    }),
  ]);

  // Facets
  instant.facets.widgets.forEach(function(widget) {
    instant.search.addWidgets([widget.widget(widget.params)]);
  });

  if ($('[class~="ais-facet-meta.yotpo.reviews_average-container"]').length) {
    instant.search.addWidgets([
      ratingMenu({
        container: "[class~='ais-facet-meta.yotpo.reviews_average-container']",
        attribute: "meta.yotpo.reviews_average",
      })
    ]);
  }

  // Hide empty facets
  instant.search.addWidgets([
    {
      render: function(opts) {
        $('.ais-facet-item').each(function() {
          if ($(this).find('.ais-RefinementList--noRefinement').length !== 0) {
            $(this).hide();
          } else {
            $(this).show();
          }
        });

        if ($('[class~="ais-facet-meta.yotpo.reviews_average"]').length) {
          var disabledRatings = 0;
          $('[class~="ais-facet-meta.yotpo.reviews_average"] .ais-RatingMenu-item').each(function() {
            if ($(this).hasClass('ais-RatingMenu-item--disabled')) {
              disabledRatings++;
            }
          });

          if (disabledRatings == $('[class~="ais-facet-meta.yotpo.reviews_average"] .ais-RatingMenu-item').length) {
            $('[class~="ais-facet-meta.yotpo.reviews_average"]').hide();
          } else {
            $('[class~="ais-facet-meta.yotpo.reviews_average"]').show();
          }
        }
      }
    }
  ]);

  // Hits
  instant.search.addWidgets([
    hits({
      container: '.ais-hits-container',
      templates: {
        empty: instant.templates.empty,
        item: instant.templates.product,
      },
      escapeHTML: false,
      transformItems: function(products) {
        return products.map(function(product) {
          var color = product.options.color;
          var sellable = product.inventory_management !== 'shopify' || product.inventory_policy === 'continue' || product.variants_inventory_count > 0;
          if (product.options.format == 'Streaming Video') {
            var showVideoBadge = true;
          }

          localStorage.setItem("queryID", product.__queryID)

          return algolia.assign({}, product, {
            _distinct: instant.distinct,
            add_to_cart: product.variants_count == 1 && sellable,
            totalProducts: products.length,
            can_order: sellable,
            translations: algolia.translations,
            queryID: product.__queryID,
            productPosition: product.__position,
            index: instant.search.mainIndex.getIndexName(),
            is_ebook_variant: product.options.format == 'eBook',
            is_video_variant: showVideoBadge,
            is_audio_variant: function() {
              if (product.options.format && product.options.format.includes("Digital Audio")) {
                return product.options.format.includes("Digital Audio");
              } else {
                return null
              }
            }(),
            // is_ecourse_variant: showEcourseBadge,
            ebook: product.tags.indexOf('eBook') !== -1,
            swatchColor: color,
            digital_type: function() {
              for (var i = 0; i < product.tags.length; i++) {
                var isDigitalTag = false;
                var modifiedDigital = product.tags[i].replaceAll(' ', '').replaceAll('-', '').toLowerCase();
                if (modifiedDigital.indexOf('ebook') != -1) {
                  return 'eBook';
                }
                if (modifiedDigital.indexOf('audiobook') != -1) {
                  // return 'Audiobook';
                }
                // if (modifiedDigital.indexOf('ecourse') != -1) {
                //   return 'eCourse';
                // }
              }
            }(),
          });
        });
      },
    }),
  ]);

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value));
  };

  // Handleize function
  var handleize = function(str) {
    str = str.toLowerCase();
    var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
    for (var i = 0; i < toReplace.length; ++i) {
      str = str.replace(toReplace[i], "");
    }

    str = str.replace(/\W+/g, "-");

    if (str.charAt(str.length - 1) == "-") {
      str = str.replace(/-+\z/, "");
    }

    if (str.charAt(0) == "-") {
      str = str.replace(/\A-+/, "");
    }
    return str
  };

  // Update products
  instant.search.addWidgets([
    {
      render: function(opts) {
        // Add color swatches
        $('.ais-hit').each(function() {
          var $thisHit = $(this);
          var handle = $(this).attr('data-handle');
          var id = $(this).attr('data-algolia-objectid');
          var selectedColor = $(this).attr('data-swatch-color');
          var hasColor = false;

          $.getJSON('/products/' + handle + '.js', function(product) {
            var variantsArray = product.variants;
            var optionsArray = product.options;

            // Sale Prices
            if (product.price_varies) {
              var atLeastOneOnSale = false;

              variants:
              for (var i = 0, allVars = variantsArray.length; i < allVars; i++) {
                if (variantsArray[i].compare_at_price > variantsArray[i].price) {
                  atLeastOneOnSale = true;
                  break variants;
                }
              }

              if (atLeastOneOnSale) {
                // var newPriceHtml = '<b class="ais-hit--price-discount ais-hit--price-sale">' + formatPrice(product.price_min) + ' - ' + formatPrice(product.price_max) + ' Sale</b>';
                var newPriceHtml = '<b class="ais-hit--price-discount ais-hit--price-sale">' + formatPrice(product.price_min) + ' - ' + formatPrice(product.price_max) + '</b>';
                $thisHit.find('.ais-hit--price').html(newPriceHtml);
              }
            }

            // Swatches
            var swatchesHtml = '';
            optionsLoop:
            for (var i = 0, allOpts = optionsArray.length; i < allOpts; i++) {
              if (optionsArray[i].name == 'Color') {
                hasColor = true;
                colorsLoop:
                for (var j = 0; j < optionsArray[i].values.length; j++) {
                  var variantUrl = product.url;
                  var thisColor = optionsArray[i].values[j];
                  if (thisColor == selectedColor) {
                    var selectIt = j;
                  }
                  var variantImg = '';
                  var swatchImg = '//cdn.shopify.com/s/files/1/0049/1182/4965/files/color-' + handleize(thisColor) + '.png';
                  variantsLoop:
                  for (var k = 0, allVars = variantsArray.length; k < allVars; k++) {
                    if (variantsArray[k].options[i] == thisColor) {
                      variantUrl += '?variant=' + variantsArray[k].id;
                      if (variantsArray[k].featured_image != null) {
                        variantImg = variantsArray[k].featured_image.src;
                      }
                      break variantsLoop;
                    }
                  }
                  var selectedClass = (j == selectIt) ? ' selected' : '';
                  swatchesHtml += '<a href="' + variantUrl + '" class="ais-hit--swatch ais-color-swatch' + selectedClass + '" style="background-image:url(' + swatchImg + ')" data-img="' + variantImg.replace(/(\.[^.]*)$/, "_large$1") + '"><span class="hidden">' + thisColor + '</span></a>';
                }
                break optionsLoop;
              }
            }

            if (hasColor && $('#ais-hit-swatches-' + id).length == 0) {
              $thisHit.find('.ais-hit--details').append('<div id="ais-hit-swatches-' + id + '" class="ais-hit--swatches"><div id="ais-hit-swatches-list-' + id + '" class="ais-hit--swatches-list">' + swatchesHtml + '</div></div>');

              $('#ais-hit-swatches-' + id + ' .ais-hit--swatch').click(function() {
                $(this).addClass('selected').siblings().removeClass('selected');
                $thisHit.find('.ais-hit--picture').css('background-image', 'url(' + $(this).attr('data-img') + ')');
              });

              $(document).on('mouseenter', '#ais-hit-swatches-' + id + ' .ais-hit--swatch', function(evt) {
                $thisHit.find('.ais-hit--picture').css('background-image', 'url(' + $(this).attr('data-img') + ')');
              });

              moreColorsBtn(id);
            }
          });
        });

        $(window).on('resize', function() {
          $('.ais-hit--swatches:not(.expanded)').each(function() {
            var id = $(this).closest('.ais-hit').attr('data-algolia-objectid');
            moreColorsBtn(id);
          });
        });

        function moreColorsBtn(id) {
          var swatchesList = document.getElementById('ais-hit-swatches-list-' + id);
          if (typeof swatchesList !== 'undefined') {
            if (swatchesList.clientHeight < swatchesList.scrollHeight && $('#ais-hit-swatches-more-' + id).length == 0) {
              $('#ais-hit-swatches-' + id).append('<button id="ais-hit-swatches-more-' + id + '" class="ais-hit-swatches--more">More Colors +</button>');
              $('#ais-hit-swatches-more-' + id).click(function() {
                $(this).remove();
                $('#ais-hit-swatches-list-' + id).css('height', 'auto');
                $('#ais-hit-swatches-' + id).addClass('expanded');
              });
            } else if (swatchesList.clientHeight >= swatchesList.scrollHeight) {
              $('#ais-hit-swatches-more-' + id).remove();
            }
          }
        }

        try {
          // Re-render reviews
          if (typeof Yotpo !== 'undefined') {
            var api = new Yotpo.API(yotpo);
            api.refreshWidgets();
          }
        } catch (e) {
          console.warn(e);
        }
      }
    }
  ]);

  // Product click events
  instant.search.addWidgets([
    {
      init: function() {
        // Add to Cart button click
        $(document).on('click touchstart', '.ais-hit--atc-button', function(e) {
          var $hit = $(this).closest('.ais-hit');
          var el = e.target;

          if (!$hit) {
            return;
          }

          e.preventDefault();
          e.stopImmediatePropagation();
          addToCart(el);
        });

        $(document).on('click touchstart', '.ais-hit--picture.ais-hit--link, .ais-hit--link, .ais-hit--details .yotpo-display-wrapper a', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation()

          var $hit = $(this).closest('.ais-hit');
          var el = e.target;

          if (!$hit) {
            return;
          }

          if (el.matches('.ais-hit--atc-button')) {
            // Add to Cart
            addToCart(el);
          } else if (el.matches('.ais-hit--options-button')) {
            pdpLink($hit);
          } else {
            if (e.type == 'touchstart') {
              // Mobile, show button, do not go to PDP
              $(this).focus();
            } else {
              // Normal click, go to PDP
              pdpLink($hit);
            }
          }
        });

        function pdpLink($hit) {
          var productHandle = $hit.attr('data-handle');
          var variant_id = $hit.attr('data-variant-id');

          var link = '/products/' + productHandle;
          link += '?variant=' + variant_id;

          if (algolia.config.analytics_enabled) {
            if ($hit[0].dataset != null) {
              var clickData = {
                index: $hit[0].dataset.algoliaIndex,
                eventName: 'click',
                queryID: $hit[0].dataset.algoliaQueryid,
                objectIDs: [$hit[0].dataset.algoliaObjectid],
                positions: [Number($hit[0].dataset.algoliaPosition)],
              };
              // Send the click event
              aa.clickedObjectIDsAfterSearch(clickData);
              /**
               * Uncomment the following function call to start storing data in
               * local storage for conversion tracking
               */
              algolia.saveForConversionTracking(clickData);
            } else {
              window.location.href = link;
            }
          }
          window.location.href = link;
        }

        function addToCart(cartButton) {
          var $this = cartButton;
          var formId = $this.dataset.formId;
          if (formId) {
            var isEbook = $this.dataset.isEbook;
            if (isEbook == 'true') {
              var thisId = $('#' + formId + ' [name="id"]').val();
              $.getJSON('/cart.js', function(cart) {
                var hasThisEbook = false;
                for (var i = 0; i < cart.items.length; i++) {
                  if (cart.items[i].id == thisId) {
                    hasThisEbook = true;
                    break;
                  }
                }
                if (hasThisEbook) {
                  alert('This eBook is already in your cart.');
                } else {
                  document.getElementById(formId).submit();
                }
              });
            } else {
              document.getElementById(formId).submit();
            }
          }
        }
      },
    },
  ]);

  // Redirects function
  instant.search.addWidgets([
    queryRuleCustomData({
      container: '#redirectFunction',
      templates: {
        default: '',
      },
      transformItems(items) {
        const match = items.find(data => Boolean(data.redirect));
        if (match && match.redirect) { window.location.href = match.redirect; }
        return [];
      },
    })
  ]);

  // No result actions
  instant.search.addWidgets([
    {
      init: function(opts) {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearFilters;
          do {
            if (el.matches('.ais-hit-empty--clear-filters')) {
              clearFilters = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearFilters) {
            return;
          }

          var helper = opts.helper;
          helper.clearTags();
          instant.facets.list.forEach(function(facet) {
            helper.clearRefinements(facet.name);
          });
          helper.search();
        });

        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearInput;
          do {
            if (el.matches('.ais-hit-empty--clear-input')) {
              clearInput = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearInput) {
            return;
          }

          opts.helper.setQuery('').search();
          var input = document.querySelector('.ais-search-box--input');
          input.value = '';
          input.focus();
        });
      },
    },
  ]);

  const virtualRefinementList = connectRefinementList(
    () => null
  );

  instant.search.addWidgets([
    virtualRefinementList({
      attribute: "named_tags.Series",
    })
  ]);

  // Pagination
  instant.search.addWidgets([
    pagination({
      container: '.ais-pagination-container',
      padding: 2,
      maxPages: 20,
    }),
  ]);

  // Main
  instant.search.start();

  algolia.contentHide.parentNode.removeChild(algolia.contentHide);
})(window.algoliaShopify);